import {parseGIF, decompressFrames} from 'gifuct-js';
import type {ParsedGif, ParsedFrameWithoutPatch} from 'gifuct-js';

const FALLBACK_FRAME_DELAY = 10; // hundredths of a second (100ms)

const normalizeDelay = (delay?: number): number => {
  const value = typeof delay === 'number' ? delay : 0;
  return value > 0 ? value : FALLBACK_FRAME_DELAY;
};

const buildGifInfo = (gif: ParsedGif, frames: ParsedFrameWithoutPatch[], url: string) => {
  const totalHundredths = frames.reduce((acc, frame) => acc + normalizeDelay(frame.delay), 0);
  const descriptor = gif.lsd;

  return {
    url,
    width: descriptor?.width ?? 0,
    height: descriptor?.height ?? 0,
    duration: totalHundredths * 10,
    valid: Boolean(descriptor),
  };
};

const loadGifInfo = async (url: string) => {
  const buffer = await fetch(url).then((res) => res.arrayBuffer());
  const gif = parseGIF(buffer);
  const frames = decompressFrames(gif, false);

  return buildGifInfo(gif, frames, url);
};

interface GifInfo {
  url: string;
  width: number;
  height: number;
  duration: number;
  valid: boolean;
}

export default async (url: string): Promise<GifInfo> => {
  try {
    return await loadGifInfo(url);
  } catch (error) {
    console.warn('Failed to parse GIF metadata', error);
    return {
      url,
      width: 0,
      height: 0,
      duration: 0,
      valid: false,
    };
  }
};
